import { render, staticRenderFns } from "./FormConfirmPass.vue?vue&type=template&id=7ae1b384&scoped=true&"
import script from "./FormConfirmPass.vue?vue&type=script&lang=js&"
export * from "./FormConfirmPass.vue?vue&type=script&lang=js&"
import style0 from "./FormConfirmPass.vue?vue&type=style&index=0&id=7ae1b384&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae1b384",
  null
  
)

export default component.exports